export enum LoaderVisibleType {
  Show,
  Hide,
  Restart,
}
